import React from 'react';

import {
	EXTERNAL_LINK_HAP,
	CHAT_ROOMS_HAP,
	PRODUCT_CODE,
	PRODUCT_NAME,
	ProductEnum,
	PRODUCT_FOOTER_NAME,
	PRODUCT_LINK_IOS_STORE,
	PRODUCT_LINK_ANDROID_STORE,
} from 'presentation/constants';
import {HapvidaLogo, HapvidaIcon, HapvidaAns, HapvidaAppIcon} from 'presentation/components/Logos';
import {hapTheme} from 'presentation/themes/hap.styles';
import {AnsLogoProps, ProductIconProps, ProductLogoProps} from '../types';

export const hapvidaData = {
	productLogo: ({invertColor, nameColor, ...props}: ProductLogoProps) => (
		<HapvidaLogo
			nameColor={nameColor || (invertColor ? hapTheme.brand.primary.white : undefined)}
			{...props}
		/>
	),
	productIcon: (props: ProductIconProps) => <HapvidaIcon {...props} />,
	productAppIcon: (props: ProductIconProps) => <HapvidaAppIcon {...props} />,
	ansLogo: (props?: AnsLogoProps) => <HapvidaAns {...props} />,
	product: ProductEnum.HAP,
	productCode: PRODUCT_CODE.hap,
	productName: PRODUCT_NAME.hap,
	footerProductName: PRODUCT_FOOTER_NAME.hap,
	links: EXTERNAL_LINK_HAP,
	chatRoom: CHAT_ROOMS_HAP,
	iosStoreLink: PRODUCT_LINK_IOS_STORE.hap,
	androidStoreLink: PRODUCT_LINK_ANDROID_STORE.hap,
};
